import React, { useEffect, useState } from "react";
import { Check, Download, Loader2, Printer } from "lucide-react";
import { toast } from "sonner";

import { baixarPngMesa, qrComoDataUri } from "./api";
import { imprimirNaTermica } from "./imprimirNaTermica";

// Uma mesa na janela "QR Codes das mesas": miniatura do QR (com o nome no
// meio), marcar para o PDF/impressão em massa e as ações só desta mesa.
export default function CartaoQrMiniatura({ mesa, marcada, onAlternar, onAtualizarNome }) {
  const [imagem, setImagem] = useState(null);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    let vivo = true;
    setImagem(null);
    setErro(false);
    qrComoDataUri(mesa.id)
      .then((uri) => { if (vivo) setImagem(uri); })
      .catch(() => { if (vivo) setErro(true); });
    return () => { vivo = false; };
  }, [mesa.id, mesa.nome_qr]);

  const baixar = async () => {
    try {
      await baixarPngMesa(mesa);
    } catch {
      toast.error("Não consegui baixar a imagem.");
    }
  };

  return (
    <div
      className={`rounded-xl border p-2 flex flex-col gap-2 transition ${
        marcada ? "border-primary ring-1 ring-primary" : "border-border"
      }`}
      data-e2e="qr-massa-cartao"
    >
      <button
        type="button"
        onClick={onAlternar}
        className="flex items-center gap-2 text-left min-w-0"
        aria-pressed={marcada}
      >
        <span className={`w-5 h-5 shrink-0 rounded-md border flex items-center justify-center ${
          marcada ? "bg-primary border-primary text-primary-foreground" : "border-muted-foreground/40"
        }`}>
          {marcada ? <Check className="w-3.5 h-3.5" /> : null}
        </span>
        <span className="text-sm font-bold truncate">{mesa.nome}</span>
      </button>

      <button type="button" onClick={onAlternar} className="rounded-lg bg-white p-1 aspect-square">
        {imagem ? (
          <img src={imagem} alt={`QR da ${mesa.nome}`} className="w-full h-full object-contain" />
        ) : (
          <span className="w-full h-full flex items-center justify-center text-[11px] text-neutral-500">
            {erro ? "Sem imagem" : <Loader2 className="w-5 h-5 animate-spin" />}
          </span>
        )}
      </button>

      {mesa.nome_qr_diferente ? (
        <div className="rounded-lg bg-amber-500/10 border border-amber-500/30 px-2 py-1.5 text-[11px] leading-snug">
          No QR está <strong>{mesa.nome_qr}</strong>.{" "}
          <button type="button" onClick={onAtualizarNome} className="font-bold underline underline-offset-2">
            Trocar para {mesa.nome}
          </button>
        </div>
      ) : null}

      <div className="flex gap-1.5">
        <button
          type="button"
          onClick={baixar}
          title="Baixar a imagem do QR Code desta mesa"
          className="flex-1 h-8 rounded-lg border border-border text-[11px] font-bold flex items-center justify-center gap-1 hover:bg-muted"
        >
          <Download className="w-3.5 h-3.5" /> Imagem
        </button>
        <button
          type="button"
          onClick={() => imprimirNaTermica([mesa.id])}
          title="Imprimir o cartão desta mesa na impressora do caixa"
          className="flex-1 h-8 rounded-lg border border-border text-[11px] font-bold flex items-center justify-center gap-1 hover:bg-muted"
        >
          <Printer className="w-3.5 h-3.5" /> Imprimir
        </button>
      </div>
    </div>
  );
}
